import { Pagination } from '../components/primitives';
import { testId } from '../utils';
import { useTranslation } from '@rpi/i18n';
import { useMemo, useState } from 'react';
import invariant from 'tiny-invariant';

export const usePagination = <T,>(
  data: T[],
  itemsPerPage: number,
  testIdParent: string,
) => {
  invariant(itemsPerPage !== 0, 'itemsPerPage must be > 0');

  const { t } = useTranslation(undefined, { keyPrefix: 'route.pagination' });

  const [pageIndex, setPageIndex] = useState(0);
  const total = data.length;

  const startIndex = pageIndex * itemsPerPage;

  const currentItems: T[] = useMemo(
    () => data.slice(startIndex, startIndex + itemsPerPage),
    [data, startIndex, itemsPerPage],
  );

  const pageRange = useMemo(() => {
    if (total === 1) return t('one_project');
    return itemsPerPage >= total
      ? t('projects', { totalCount: total })
      : t('page_range', {
          startIndex: startIndex + 1,
          endIndex: startIndex + currentItems.length,
          totalCount: total,
        });
  }, [total, itemsPerPage, startIndex, currentItems.length, t]);

  const pagination = total !== 0 && (
    <div className="flex justify-center max-w-350">
      <Pagination
        {...testId(testIdParent, 'pagination')}
        currentPage={pageIndex}
        totalPages={Math.ceil(total / itemsPerPage)}
        edgePageCount={1}
        middlePagesSiblingCount={1}
        setCurrentPage={setPageIndex}
      />
    </div>
  );
  return {
    setPageIndex,
    currentItems,
    pagination,
    pageRange,
  } as const;
};
